import { SystemError } from './SystemError';

export default SystemError;
